module.exports = __webpack_public_path__ + "img/austria-neoplasm-female.cf54d5cc.png";